import {
  EscritoFormInitialValues,
  EscritosFormValues
} from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import AsuntoMapping from 'src/contexts/EscritoContext/EscritoMapping/AsuntoMapping'
import MonitorioMapping from 'src/contexts/EscritoContext/EscritoMapping/MonitorioMapping'
import PersonacionMapping from 'src/contexts/EscritoContext/EscritoMapping/PersonacionMapping'
import TramiteMapping from 'src/contexts/EscritoContext/EscritoMapping/TramiteMapping'
import { TipoMensaje } from 'src/enums/EscritosLegales'
import { Escrito } from 'src/interfaces/EscritosLegales/index'

function useEscritoMapping(): any {
  function mapping(escrito: Escrito, tipoMensaje: TipoMensaje): EscritosFormValues {
    switch (tipoMensaje) {
      case TipoMensaje.ESCRITO:
        return TramiteMapping(escrito)
      case TipoMensaje.MONITORIO:
        return MonitorioMapping(escrito)
      case TipoMensaje.INICIADOR_ASUNTO:
      case TipoMensaje.INICIADOR_EJECUCION:
        return AsuntoMapping(escrito)
      case TipoMensaje.PERSONACION:
        return PersonacionMapping(escrito)
      default:
        return { ...EscritoFormInitialValues }
    }
  }
  return {
    mapping
  }
}

export default useEscritoMapping
